(() => {
  if (window.__FURMILY_BUNDLE_CLEANUP__) return;
  window.__FURMILY_BUNDLE_CLEANUP__ = true;

  const FOUNTAIN_PRODUCTS = new Set(['16016027058557','16029494313341']);
  const SUB_VARIANT = '58649027150205';
  let running = null;

  const route = (name, fallback) => window.routes?.[name] || fallback;
  const cartJsonUrl = () => {
    const base = route('cart_url','/cart');
    return base.endsWith('.js') ? base : base + '.js';
  };

  const getCart = async () => {
    const response = await fetch(cartJsonUrl(), {
      credentials:'same-origin',
      cache:'no-store',
      headers:{ Accept:'application/json' }
    });
    if (!response.ok) throw new Error('Cart read failed.');
    return response.json();
  };

  const updateLines = async (updates) => {
    if (!Object.keys(updates).length) return null;

    const response = await fetch(route('cart_update_url','/cart/update.js'), {
      method:'POST',
      credentials:'same-origin',
      cache:'no-store',
      headers:{
        Accept:'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({ updates })
    });

    const raw = await response.text();
    let data = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch {}

    if (!response.ok || data?.status >= 400 || data?.errors) {
      throw new Error(data?.description || data?.message || 'Cart cleanup failed.');
    }
    return data;
  };

  const refreshSurfaces = async (itemCount) => {
    document.querySelector('cart-items')?.onCartUpdate?.();

    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.classList.contains('active')) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sections','cart-drawer');

    const response = await fetch(url.toString(), {
      credentials:'same-origin',
      cache:'no-store',
      headers:{
        Accept:'application/json',
        'X-Requested-With':'XMLHttpRequest'
      }
    });

    if (!response.ok) return;

    drawer.renderContents?.({ sections:await response.json() });
    if (Number.isFinite(itemCount)) drawer.syncHeaderCartCount?.(itemCount);
    else drawer.refreshHeaderCartCount?.();
    window.setTimeout(() => window.FurMilyOrderCartBundles?.(), 0);
  };

  const sync = () => {
    if (running) return running;

    running = (async () => {
      const cart = await getCart();

      const fountainTokens = new Set(
        (cart.items || [])
          .filter((item) =>
            FOUNTAIN_PRODUCTS.has(String(item.product_id)) &&
            Boolean(item.properties?._furmily_bundle_token)
          )
          .map((item) => item.properties._furmily_bundle_token)
      );

      const updates = {};

      for (const item of cart.items || []) {
        const token = item.properties?._furmily_bundle_token;
        if (!token || fountainTokens.has(token)) continue;

        const managedGift = item.properties?._fm_managed === 'gift';
        const managedSub =
          String(item.variant_id) === SUB_VARIANT &&
          item.properties?._fm_managed === 'save-more-subscription';

        if (managedGift || managedSub) {
          updates[item.key] = 0;
        }
      }

      if (!Object.keys(updates).length) return cart;

      window.FurmilySetCheckoutBusy?.(true);
      let cleanedCart;
      try {
        cleanedCart = await updateLines(updates);
        await refreshSurfaces(cleanedCart?.item_count);
      } finally {
        window.FurmilySetCheckoutBusy?.(false);
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source:'furmily-bundle-cleanup',
            cartData:cleanedCart
          });
        } catch {}
      }

      return cleanedCart;
    })()
      .catch((error) => console.error('[FurMily cleanup]', error))
      .finally(() => { running = null; });

    return running;
  };

  window.FurMilyGiftSync = sync;

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event={}) => {
      if (
        event.source === 'furmily-atomic-atc' ||
        event.source === 'furmily-bundle-remove' ||
        event.source === 'furmily-bundle-cleanup'
      ) return;

      window.setTimeout(() => { void sync(); }, 80);
    });
  }

  const scheduleStartupCleanup = () => {
    const run = () => { void sync(); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 4000 });
    } else {
      window.setTimeout(run, 1500);
    }
  };

  if (document.readyState === 'complete') {
    scheduleStartupCleanup();
  } else {
    window.addEventListener('load', scheduleStartupCleanup, { once:true });
  }
})();